import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-outline mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "name"
}, "Layer name", -1)
const _hoisted_3 = ["disabled"]

import ModalDialog from "@/components/Modals/ModalDialog.vue";
import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewLayerDialog',
  setup(__props, { expose }) {

let data = reactive({
	name: null as string,
	show: false,
})

let promiseResolve: any;

function show(): Promise<string | null> {
	data.show = true;
	data.name = "";
	return new Promise((resolve) => {
		promiseResolve = resolve;
	});
}

function hide() {
	data.show = false;
	if (promiseResolve) {
		promiseResolve(null);
		promiseResolve = null;
	}
}

async function create() {
	data.show = false;
	if (promiseResolve) {
		promiseResolve(data.name);
		promiseResolve = null;
	}
}

expose({
	show
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDialog, {
    visible: _unref(data).show,
    title: "New layer"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            name: "name",
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).name) = $event))
          }, null, 512), [
            [_vModelText, _unref(data).name]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-link me-4",
            onClick: hide
          }, "Cancel"),
          _createElementVNode("button", {
            disabled: !_unref(data).name,
            class: "btn",
            onClick: create
          }, "Create", 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})